import SysTable from "app/class/sys-table";
import { axiosInterceptor } from "../request-interceptor";
import SysColumn from "app/class/sys-column";

type SysIndexPayload = {
    id?: string;
    sys_table_id?: string;
    table_name?: string;
    name?: string;
    physical_name?: string;
    unique?: boolean;
    active?: boolean;
    description?: string;
    columns?: Array<{
        id?: string;
        sys_column_id?: string;
        column_id?: string;
        name?: string;
        column_name?: string;
        order?: number;
        sort_direction?: "asc" | "desc";
    }>;
}

// const getSingleTable = async (id: string) => {
//     return axiosInterceptor.get<SysTable>("/api/records/sys_tables/" + id);
// }

// const getTables = async () => {
//     return axiosInterceptor.get<SysTable[]>("/api/records/sys_tables");
// }

const postTable = async (table: SysTable) => {
    return axiosInterceptor.post<SysTable>("/api/records/sys_tables", { sys_table: table });
}

const deleteTable = async (id: string) => {
    return axiosInterceptor.delete("/api/records/sys_tables/" + id);
}

// const getTableColumns = async (tableId: string) => {
//     return axiosInterceptor.get<SysColumn[]>("/api/records/sys_columns?_query=sys_table_id=" + tableId);
// }

// const getAllColumns = async () => {
//     return axiosInterceptor.get<SysColumn[]>("/api/records/sys_columns");
// }

const postColumn = async (column: SysColumn) => {
    return axiosInterceptor.post<SysColumn>("/api/records/sys_columns", column);
}

const updateColumn = async (id: string, column: SysColumn) => {
    return axiosInterceptor.put<SysColumn>("/api/records/sys_columns/" + id, column);
}

const deleteColumn = async (id: string) => {
    return axiosInterceptor.delete("/api/records/sys_columns/" + id);
}

const postIndex = async (index: SysIndexPayload) => {
    return axiosInterceptor.post("/api/records/sys_indexes", { sys_index: index });
}

const deleteIndex = async (id: string) => {
    return axiosInterceptor.delete("/api/records/sys_indexes/" + id);
}

const buildIndex = async (id: string) => {
    return axiosInterceptor.post("/api/records/sys_indexes/" + id + "/build");
}

export const tableApi = { postTable, deleteTable, postColumn, updateColumn, deleteColumn, postIndex, deleteIndex, buildIndex }; // getSingleTable, getTables, getTableColumns, getAllColumns,
export { postTable, deleteTable, postColumn, updateColumn, deleteColumn, postIndex, deleteIndex, buildIndex }; // getSingleTable, getTables, getTableColumns, getAllColumns,
export default tableApi;